// extracted by mini-css-extract-plugin
export var closeButton = "_bz-1";
export var closeX = "_bz-3";
export var container = "_bz-0";
export var image = "_bz-2";